import React, { useEffect, useRef, useState } from "react";
import { MdApps } from "react-icons/md";
import { FaProjectDiagram, FaLanguage, FaGlobeAmericas } from "react-icons/fa";
import CountUp from "react-countup";

const statsData = [
  {
    icon: MdApps,
    number: 1000,
    suffix: "+",
    description: "ERPS",
  },
  {
    icon: FaProjectDiagram,
    number: 1500,
    suffix: "+",
    description: "Consulting Categories",
  },
  {
    icon: FaLanguage,
    number: 8,
    suffix: "",
    description: "Languages",
  },
  {
    icon: FaGlobeAmericas,
    number: 9999,
    suffix: "+",
    description: "Worldwide consultants",
  },
];

function Community() {
  const [startCount, setStartCount] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStartCount(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <div ref={sectionRef} className="max-w-7xl mx-auto my-20 px-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {statsData.map((item, index) => {
          const Icon = item.icon;

          return (
            <div
              key={index}
              className="
                group
                py-12 px-4 rounded-2xl text-center shadow-md cursor-pointer
                transition-all duration-300
                hover:bg-gradient-to-r
                hover:from-[#FFA500]
                hover:to-[#6a760c]
              "
            >
              {/* Icon */}
              <Icon
                size={40}
                className="mx-auto text-[#C44251] transition-colors duration-300 group-hover:text-white"
              />

              {/* Number */}
              <h6 className="py-6 text-[#315F6F] text-5xl font-bold transition-colors duration-300 group-hover:text-white">
                {startCount ? (
                  <CountUp
                    start={0}
                    end={item.number}
                    duration={2}
                    separator=","
                    suffix={item.suffix}
                  />
                ) : (
                  "0" + item.suffix
                )}
              </h6>

              {/* Description */}
              <p className="font-semibold text-lg italic transition-colors duration-300 group-hover:text-white">
                {item.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Community;
